const user = {
    'state': {
        // 'accountType': 1,
        'email': null,
        'fullName': null,
        'userRole': 1,
        'userId': null,
        'isCompanyUser': false,
        'identityCardNumber': null,
        'staffId': null,
        'isProfileCompleted': null,
        'companyType': 0,
        'isSpouseOrDependent': false,
        'spouseOrDependentCompanyType': 0,
        'clinicProviderType': 1
    },
    'mutations': {
        setUserDetails (state, apiData) {
            // state.accountType = apiData.a;
            state.email = apiData.e;
            state.fullName = apiData.n;
            state.userRole = apiData.r;
            state.userId = apiData.u;
            state.isCompanyUser = !!apiData.ci;
            state.identityCardNumber = apiData.icn;
            state.staffId = apiData.sid;
            state.isProfileCompleted = apiData.ipc;
            state.companyType = apiData.ct;
            state.isSpouseOrDependent = apiData.isd;
            state.spouseOrDependentCompanyType = apiData.pct;
            state.clinicProviderType = apiData.cpt;
        },
        clearUserState (state) {
            // state.accountType = 1;
            state.email = null;
            state.fullName = null;
            state.userRole = 1;
            state.userId = null;
            state.identityCardNumber = null;
            state.staffId = null;
            state.isProfileCompleted = null;
            state.companyType = 0;
            state.isSpouseOrDependent = false;
            state.spouseOrDependentCompanyType = 0;
            state.clinicProviderType = 1;
        },
        completedProfile (state) {
            state.isProfileCompleted = 1;
        }
    }
};

export default user;
